const getCashierLink = (pathname: string, cashierPath: string) =>
  `${pathname}?c=${cashierPath}`;

export default getCashierLink;
